export const jobPreventedFromEmailingBy = ({ primaryContactId, postedToXero, email }) => {
  const errors = [
    primaryContactId ? null : 'No Primary Contact',
    email ? null : 'Contact has no email address',
    postedToXero ? null : 'Not posted to Xero',
  ].filter(Boolean)

  return errors
}
